<template>
  <div
    class="parent-source"
    :class="{ open: openCategory === sourceCategory }"
    @click="$emit('update:openCategory', sourceCategory)"
  >
    <div class="d-flex align-center justify-start pa-3">
      <v-icon
        :icon="openCategory === sourceCategory ? '$chevron-up' : '$chevron-down'"
        size="18px"
        class="mr-2"
        color="iconDefault"
      />
      <span class="source-category-label new-h3">{{ sourceCategoryTitles[sourceCategory] }}</span>
      <SubmissionRateChip
        v-if="openCategory !== sourceCategory"
        :fill-rate="fillRate"
        class="ml-3"
      >
        {{ `${Math.round(fillRate)}% of ${sourceCategoryTitles[sourceCategory]} candidates have submitted the survey` }}
      </SubmissionRateChip>
    </div>
    <div class="submission-rate-chip-container">
      <span
        v-if="openCategory === sourceCategory"
        class="sources-count new-body-text"
      >
        Submission Rate
      </span>
    </div>
    <div
      v-if="openCategory === sourceCategory"
      class="candidates-container"
    >
      <span class="sources-count new-body-text">
        Candidates
      </span>
    </div>
    <div
      v-else-if="sources && openCategory !== sourceCategory"
      class="d-flex align-center justify-end"
    >
      <span class="sources-count new-body-text pr-3">
        {{ sources.length }} {{ sources.length === 1 ? 'source' : 'sources' }}
      </span>
    </div>
  </div>
</template>

<script setup>
import SubmissionRateChip from '@/components/insights/ProcessInsights/DemographicSurveyReport/SubmissionRateChip.vue';
import { sourceCategoryTitles } from '@/components/insights/ProcessInsights/DemographicSurveyReport/tables/helpers';

defineProps({
  sourceCategory: { type: String, required: true },
  fillRate: { type: Number, required: true },
  sources: { type: Array, required: true },
  openCategory: { type: String, default: '' },
});

defineEmits(['update:openCategory']);

</script>

<style lang="less" scoped>
.parent-source {
  width: 100%;
  cursor: pointer;
  display: grid;
  grid-template-columns: 505px minmax(0, 200px) minmax(85px, 1fr);

  &.open {
    grid-template-columns: minmax(200px, 505px) minmax(0, 200px) minmax(85px, 100px);
  }
}

.source-category-label {
  color: @text-darkest;
}

.submission-rate-chip-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
}

.sources-count {
  color: @text-lighter;
}

.candidates-container {
  max-width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
